import { render, staticRenderFns } from "./PhoneTitle.vue?vue&type=template&id=2e0cd0b1&"
import script from "./PhoneTitle.vue?vue&type=script&lang=js&"
export * from "./PhoneTitle.vue?vue&type=script&lang=js&"
import style0 from "./PhoneTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports